module.exports = __webpack_public_path__ + "img/icon-bulk-message-gray.e17f9266.svg";